<div class="qa-multi-value-options">
  <div class="qa-multi-value-row" *ngFor="let field of question.elements; let position = index;">
    <div class="qa-multi-value-header">
      <span class="qa-option-number">{{position + 1}}</span>
      <span class="qa-multi-value-kind">{{getFieldTypeLabel(field)}}</span>
      <div class="qa-option-order">
        <button type="button" (click)="onPositionChange(position, position - 1)" [disabled]="position === 0"
                [attr.aria-label]="_(KEYS.EDITOR.MOVE_UP)"><i class="fa fa-angle-up"></i></button>
        <button type="button" (click)="onPositionChange(position, position + 1)" [disabled]="position === question.elements.length - 1"
                [attr.aria-label]="_(KEYS.EDITOR.MOVE_DOWN)"><i class="fa fa-angle-down"></i></button>
      </div>
      <div ngbDropdown container="body" placement="bottom-right">
        <button type="button" class="qa-option-more" ngbDropdownToggle [attr.aria-label]="_(KEYS.EDITOR.OPTIONS) + ': ' + (position + 1)">
          <i class="fa fa-ellipsis-v"></i>
        </button>
        <div ngbDropdownMenu class="qa-option-menu">
          <button ngbDropdownItem (click)="onToggleFieldMandatory(field)" [attr.aria-pressed]="!!field.options?.mandatory">
            <i class="fa" [ngClass]="field.options?.mandatory ? 'fa-check-square-o' : 'fa-square-o'"></i> {{_(KEYS.EDITOR.MANDATORY)}}
          </button>
          <button ngbDropdownItem (click)="onToggleMark(field)" [attr.aria-pressed]="!!field.conditions?.mark">
            <i class="fa" [ngClass]="field.conditions?.mark ? 'fa-bookmark' : 'fa-bookmark-o'"></i> {{_(KEYS.EDITOR.MARK)}}
          </button>
          <button ngbDropdownItem (click)="onScoringModal(position)"><i class="fa fa-sort-numeric-asc"></i> {{_(KEYS.EDITOR.SCORING)}}</button>
          <button ngbDropdownItem (click)="onVariablesModal(position)"><i class="fa fa-code"></i> {{_(KEYS.EDITOR.VARIABLES)}}</button>
          <div class="dropdown-divider"></div>
          <button ngbDropdownItem class="text-danger" (click)="onDeleteField(position)"><i class="fa fa-trash-o"></i> {{_(KEYS.EDITOR.REMOVE)}}</button>
        </div>
      </div>
    </div>
    <label class="qa-multi-value-label">
      <span>{{_(KEYS.EDITOR.TITLE)}}</span>
      <textarea #fieldTitle class="form-control qa-multi-value-title" rows="1" wrap="soft"
                cdkTextareaAutosize cdkAutosizeMinRows="1" [value]="field.title?.[locale] || ''"
                (input)="onFieldTitleInput(position, $event)" (keydown.enter)="$event.preventDefault()"
                (beforeinput)="onFieldTitleBeforeInput($event)" [placeholder]="_(KEYS.EDITOR.ENTER_TITLE)"></textarea>
    </label>
    <div class="qa-multi-value-fields">
      <label class="qa-multi-value-label">
        <span>{{_(KEYS.EDITOR.QUESTIONNAIRE_TYPE)}}</span>
        <select class="form-control custom-select qa-multi-value-type-select" [ngModel]="field.format || 'text'"
                (ngModelChange)="onFieldTypeChange(field, $event)">
          <option *ngFor="let type of fieldTypes" [value]="type.value">{{_(type.labelKey)}}</option>
        </select>
      </label>
      <label class="qa-multi-value-label qa-multi-value-width">
        <span>{{_(KEYS.EDITOR.WIDTH_PERCENT)}}</span>
        <input class="form-control qa-multi-value-width-input" type="number" min="1" max="100" placeholder="%"
               [ngModel]="field.options?.widthPercent || null" (ngModelChange)="onFieldWidthChange(position, $event)" />
      </label>
    </div>
    <div class="qa-multi-value-meta" *ngIf="field.options?.mandatory || field.conditions?.mark || getScoringInfo(field)">
      <span *ngIf="field.options?.mandatory">{{_(KEYS.EDITOR.MANDATORY)}}</span>
      <span *ngIf="field.conditions?.mark"><i class="fa fa-bookmark"></i> {{_(KEYS.EDITOR.MARK)}}</span>
      <span *ngIf="getScoringInfo(field) as scoringInfo"><i class="fa fa-sort-numeric-asc"></i> {{scoringInfo.variableName}}: {{scoringInfo.value}}</span>
    </div>
    <button type="button" class="qa-multi-value-options-toggle" (click)="toggleFieldOptions(position)"
            [attr.aria-expanded]="!!expandedFieldOptions[position]">
      <i class="fa fa-sliders"></i> {{_(KEYS.EDITOR.OPTIONS)}}
      <i class="fa" [ngClass]="expandedFieldOptions[position] ? 'fa-angle-up' : 'fa-angle-down'"></i>
    </button>
      <div class="qa-multi-value-field-options" *ngIf="expandedFieldOptions[position]">
        <ng-container [ngSwitch]="field.format">
          <app-qa-question-text *ngSwitchCase="'text'" [question]="field"></app-qa-question-text>
          <app-qa-question-numeric *ngSwitchCase="'numeric'" [question]="field"></app-qa-question-numeric>
          <app-qa-question-date *ngSwitchCase="'date'" [question]="field"></app-qa-question-date>
          <app-qa-question-choice *ngSwitchCase="'singleChoice'" [question]="field"></app-qa-question-choice>
        </ng-container>
      </div>
    </div>


  <button type="button" class="btn btn-sm btn-primary" (click)="onAddField()">
    <i class="fa fa-plus"></i> {{_(KEYS.EDITOR.ADD_ENTRY)}}
  </button>
  <div class="qa-width-warning" *ngIf="getWidthWarning() as warning">
    <i class="fa fa-exclamation-triangle"></i> {{warning}}
  </div>
</div>
